import { ReactNode } from 'react';

import { Typography, Stack, tokens } from '@cast/design-system';

export const FormSection = ({
  description,
  title,
  children,
  action,
}: {
  title: string;
  description?: string;
  children?: ReactNode;
  action?: ReactNode;
}) => {
  return (
    <Stack gap={16}>
      <Stack gap={4}>
        <Typography variant="A1">{title}</Typography>
        {description && (
          <Typography
            variant="P12R"
            sx={{ color: tokens.theme.fg.structural.secondary }}
          >
            {description}
          </Typography>
        )}
      </Stack>

      {children}

      {action}
    </Stack>
  );
};
